import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import PriceExplanation from './components/PriceExplanation';
import InvestmentPackages from './components/InvestmentPackages';
import Calculator from './components/Calculator';
import ActivityFeed from './components/ActivityFeed';
import TrustBlock from './components/TrustBlock';
import Footer from './components/Footer';
import EarningToast from './components/EarningToast';

const HomePage = () => (
  <div className="min-h-screen" style={{ background: '#111418' }}>
    <Navbar />
    <HeroSection />
    <PriceExplanation />
    <InvestmentPackages />
    <Calculator />
    <ActivityFeed />
    <TrustBlock />
    <Footer />
    <EarningToast />
  </div>
);

export default HomePage;
